import PropTypes from "prop-types";
import { gr } from "src/design-system/tokens";
import icons from "src/design-system/icons";
import GrIcon from "src/design-system/components/GrIcon";
import GrEmptyState from "src/design-system/components/GrEmptyState";
import GrCountBadge from "src/design-system/components/GrCountBadge";
import GrDialog from "src/design-system/components/GrDialog";
import UsersList, { PEOPLE_DIALOG_WIDTH } from "./UsersList";

// "Likes" popup of a post (also used for a comment's likes by ShowCommentLikes): the people in
// `feeds_list.liked_by`, which the post / comment already carries (no extra request).
// The title shows the number of people next to "Likes" (a count pill, no extra words).
// Callers also pass showTab, post_id and feeds_type; the popup has one list, so they are not needed.
const heartStyle = { color: gr.color.danger };

export default function ShowAllLikes({
  openLikesModal,
  handleCloseSimpleBox,
  feeds_list,
}) {
  const likedBy = feeds_list?.liked_by || [];
  return (
    <GrDialog
      showClose
      open={Boolean(openLikesModal)}
      onClose={handleCloseSimpleBox}
      maxWidth={PEOPLE_DIALOG_WIDTH}
      title={
        <>
          Likes
          <GrCountBadge count={likedBy.length} />
        </>
      }
      titleIcon={<GrIcon icon={icons.heartFilled} style={heartStyle} />}
    >
      {likedBy.length ? (
        <UsersList feedActivity={likedBy} />
      ) : (
        <GrEmptyState
          compact
          icon={<GrIcon icon={icons.heart} />}
          title="No likes yet"
        />
      )}
    </GrDialog>
  );
}

ShowAllLikes.propTypes = {
  openLikesModal: PropTypes.bool,
  handleCloseSimpleBox: PropTypes.func.isRequired,
  feeds_list: PropTypes.object,
};
